<template lang="pug">

  .wrapper.wrapper-content.animated.fadeInRight
    .row
      .col-lg-12
        .ibox.float-e-margins
          .ibox-title
            h2 Map
          .ibox-content
            .map-container
              gmap-map(:center="gmapOptions.center" :zoom="gmapOptions.zoom" :options="gmapOptions.options" style="width: 100%; height: 600px;")
                gmap-marker(:position="gmapOptions.position")
          .ibox-footer
            button.btn.btn-white(@click="$router.go(-1)") Back

</template>

<script>
  export default {
    data () {
      return {
        gmapOptions: {
          center: {
            lat: Number(this.$route.query.lat),
            lng: Number(this.$route.query.lng)
          },
          position: {
            lat: Number(this.$route.query.lat),
            lng: Number(this.$route.query.lng)
          },
          zoom: 12,
          options: {
            scrollwheel: false,
            mapTypeControl: false,
            streetViewControl: false
          }
        }
      }
    },
    beforeCreate () {
      console.log(this.$route.query.lat, this.$route.query.lng)
    }
  }
</script>



// WEBPACK FOOTER //
// index.vue?28620b88